var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5833 6.6665L79.3749 9.99984L58.9582 30.4165L54.5833 6.6665Z",
    fill: "#3377EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4191 73.333L0.627441 69.9997L21.0441 49.583L25.4191 73.333Z",
    fill: "#3377EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 25.4167L9.99996 0.625L30.4166 21.0417L6.66663 25.4167Z",
    fill: "#3377EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37496 34.1665L0.624959 35.8332C0.416626 37.2915 0.416626 38.5415 0.416626 39.9998C0.416626 49.5832 3.74996 58.7498 9.99996 65.8332L16.25 60.4165C11.4583 54.7915 8.74996 47.4998 8.74996 39.9998C8.74996 38.1248 8.95829 36.0415 9.37496 34.1665Z",
    fill: "#3377EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0011 0.416504C28.7511 0.416504 18.7511 5.20817 11.4595 12.7082L17.2928 18.5415C23.1261 12.4998 31.0428 8.74984 40.0011 8.74984C41.8761 8.74984 43.9595 8.95817 45.8345 9.37484L47.2928 1.24984C45.0011 0.624837 42.5011 0.416504 40.0011 0.416504Z",
    fill: "#3377EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6274 45.8332L79.3774 44.1665C79.5857 42.7082 79.5857 41.4582 79.5857 39.9998C79.5857 30.8332 76.4607 21.8748 70.6274 14.7915L64.1691 19.9998C68.7524 25.6248 71.2524 32.7082 71.2524 39.7915C71.2524 41.8748 71.0441 43.9582 70.6274 45.8332Z",
    fill: "#3377EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7083 61.458C56.8749 67.4997 48.9583 71.2497 39.9999 71.2497C38.1249 71.2497 36.0416 71.0413 34.1666 70.6247L32.7083 78.7497C35.2083 79.1663 37.7083 79.3747 39.9999 79.3747C51.2499 79.3747 61.2499 74.583 68.5416 67.083L62.7083 61.458Z",
    fill: "#3377EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3358 54.583L70.0025 79.3747L49.5858 58.958L73.3358 54.583Z",
    fill: "#3377EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.596b971c4a24a7d6ae94fe3dee268054.svg";
export { ForwardRef as ReactComponent };